import {
  CantonState,
  caseBallotState,
  Intl,
  optionMultiLocaleString,
  outcomeFromPercent,
  BallotState,
  Percent,
} from '../../domain/index'
import { color, percentToColor, BallotVariant } from '../../materials/index'
import * as F from 'fp-ts'

/**
 * This function returns a string suitable to be used in SVG fill='…' attributes.
 * Note though that it references patterns (via url(#…)), which must be made available
 * somewhere else on the same page. In our case we render the patterns inside the
 * <Runtime> component which wraps the whole application.
 *
 * When 'forceInProgress' is true, then pre, inProgress and trend will result in
 * a striped fill.
 */
export const areaFill = (state: BallotState, forceInProgress: boolean, colorVariant: BallotVariant) => {
  const otherwise = forceInProgress ? `url(#diagonal-stripe-inProgress)` : color.grey['300']

  /*
   * When extendending, make sure the patterns exist in runtime.tsx
   */
  const mkPatternUrl = {
    default: (x: Percent) => `url(#diagonal-stripe-${outcomeFromPercent(x)})`,
    tieBreak: (x: Percent) => `url(#diagonal-stripe-${outcomeFromPercent(x)}Secondary)`,
  }[colorVariant]

  return caseBallotState({
    pre: otherwise,
    inProgress: otherwise,
    trend: () => otherwise,
    projection: ({ projection }) => mkPatternUrl(projection),
    finalResult: ({ finalResult }) => percentToColor(finalResult.votes.yea.percent, colorVariant),
  })(state)
}

export const areaFillColor = (state: BallotState, colorVariant: BallotVariant) => {
  const otherwise = color.grey['300']
  return caseBallotState({
    pre: otherwise,
    inProgress: otherwise,
    trend: () => otherwise,
    projection: ({ projection }) => percentToColor(projection, colorVariant),
    finalResult: ({ finalResult }) => percentToColor(finalResult.votes.yea.percent, colorVariant),
  })(state)
}

export const areaFillCanton = (intl: Intl, { state, info }: CantonState, colorVariant: BallotVariant) => {
  /*
   * When a info text is available, the canton will be displayed with
   * a striped background.
   */
  const forceInProgress = F.function.pipe(
    optionMultiLocaleString(intl, info),
    F.option.filter((x) => x !== ''),
    F.option.fold(
      () => false,
      () => true,
    ),
  )

  return areaFill(state, forceInProgress, colorVariant)
}
